import { CircularProgress } from '@/UI/CircularProgress/CircularProgress';
import { FlexCenHorVer } from '@/UI/styles';
import { color } from '@/colors';
import { ZIndex } from '@/consts/z-indexes.consts';

export function PageLoader() {
  return (
    <FlexCenHorVer
      sx={{
        zIndex: ZIndex.Overlays.LOADING_OVERLAY,
        background: color.Black100,
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      <CircularProgress color="inherit" />
    </FlexCenHorVer>
  );
}
